import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["itemRight", "subheading"];
import { Fragment } from 'react';
import H2 from 'UIComponents/elements/headings/H2';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import * as ScreenSizes from '../../constants/layout/ScreenSizes';
import { useResponsiveProps } from '../../hooks/useResponsiveProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function MainSectionHeading(_ref) {
  let {
      itemRight,
      subheading
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const wrapperClassName = 'm-bottom-4';
  const headingClassName = !subheading ? 'm-bottom-0' : "";
  const {
    itemRightStyles
  } = useResponsiveProps({
    itemRightStyles: {
      [ScreenSizes.SM]: {
        marginTop: 8
      },
      [ScreenSizes.MD]: {
        width: '100%',
        textAlign: 'right'
      }
    }
  });
  let renderedHeading = /*#__PURE__*/_jsx(H2, Object.assign({}, rest, {
    className: headingClassName
  }));
  if (subheading) {
    renderedHeading = /*#__PURE__*/_jsxs(Fragment, {
      children: [renderedHeading, /*#__PURE__*/_jsx("p", {
        className: "m-bottom-0",
        children: subheading
      })]
    });
  }
  if (itemRight) {
    return /*#__PURE__*/_jsxs(UIGrid, {
      className: wrapperClassName,
      children: [/*#__PURE__*/_jsx(UIGridItem, {
        size: {
          sm: 12,
          md: 8
        },
        children: renderedHeading
      }), /*#__PURE__*/_jsx(UIGridItem, {
        className: "align-self-end",
        size: {
          sm: 12,
          md: 4
        },
        children: /*#__PURE__*/_jsx("div", {
          style: itemRightStyles,
          children: itemRight
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: wrapperClassName,
    children: renderedHeading
  });
}

/**
 * @deprecated use marketplace-ui-common
 */
export default MainSectionHeading;